module.exports = __webpack_public_path__ + "img/mail.01485ce6.svg";